export const END_POINT = {
  TODO: {
    GET_TODO_ITEMS: 'api/v1/action-items',
  },
};
